import { render, staticRenderFns } from "./StopContract.vue?vue&type=template&id=0fc0f2fa&scoped=true"
import script from "./StopContract.vue?vue&type=script&lang=js"
export * from "./StopContract.vue?vue&type=script&lang=js"
import style0 from "./StopContract.vue?vue&type=style&index=0&id=0fc0f2fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc0f2fa",
  null
  
)

export default component.exports